import { Controller } from "@hotwired/stimulus"

// layout--session-health on <body> in main app layouts.
// Replaces qb.generic.js: blocks clicks on disabled controls; reloads on 401 when tab refocuses.
export default class extends Controller {
  connect() {
    document.addEventListener("visibilitychange", this.boundVisibilityChange)
    this.element.addEventListener("click", this.boundDisabledClick, true)
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.boundVisibilityChange)
    this.element.removeEventListener("click", this.boundDisabledClick, true)
  }

  boundVisibilityChange = () => {
    if (document.visibilityState !== "visible") return

    fetch("/health_check").then((resp) => {
      if (resp.status === 401) document.location.reload()
    })
  }

  boundDisabledClick = (event) => {
    const target = event.target.closest("a[disabled=disabled], input[disabled=disabled]")
    if (target) event.preventDefault()
  }
}
